import { Card, CardContent } from '@ui/card.tsx';
import { Skeleton } from '@ui/skeleton.tsx';

export function UserSkeleton() {
  return (
    <div className="space-y-10">
      <div className="space-y-4">
        <div className="flex flex-col gap-4 md:flex-row md:items-center md:justify-between">
          <div className="flex items-center gap-4">
            <Skeleton className="w-14 h-14 rounded-full" />
            <div className="space-y-2">
              <Skeleton className="w-64 h-10" />
              <Skeleton className="w-20 h-6 rounded-md" />
            </div>
          </div>
        </div>
        <div className="flex gap-3">
          <Skeleton className="w-28 h-10 rounded-full" />
          <Skeleton className="w-40 h-10 rounded-full" />
        </div>
      </div>

      <div className="grid grid-cols-1 gap-6 lg:grid-cols-3 lg:items-stretch">
        <Card className="lg:col-span-2">
          <CardContent className="space-y-8 p-6">
            <Skeleton className="w-40 h-8" />
            <div className="space-y-3">
              <Skeleton className="w-full h-6" />
              {[...Array(4)].map((_, index) => (
                <Skeleton key={index} className="w-full h-5" />
              ))}
            </div>
            <div className="space-y-3">
              <Skeleton className="w-full h-6" />
              {[...Array(5)].map((_, index) => (
                <Skeleton key={index} className="w-full h-5" />
              ))}
            </div>
          </CardContent>
        </Card>

        <div className="flex flex-col gap-6 lg:h-full">
          <Card className="flex-1">
            <CardContent className="space-y-4 p-6">
              <Skeleton className="w-28 h-8" />
              <Skeleton className="w-full h-5" />
              <Skeleton className="w-full h-5" />
            </CardContent>
          </Card>
          <Card className="flex-1">
            <CardContent className="space-y-4 p-6">
              <Skeleton className="w-28 h-8" />
              <Skeleton className="w-full h-12" />
            </CardContent>
          </Card>
        </div>
      </div>

      <Card>
        <CardContent className="space-y-6 p-10">
          <Skeleton className="w-52 h-8" />
          <Skeleton className="w-full h-48" />
          <Skeleton className="w-full h-28" />
        </CardContent>
      </Card>

      <Card>
        <CardContent className="space-y-4 p-10">
          <Skeleton className="w-56 h-8" />
          <Skeleton className="w-full h-40" />
        </CardContent>
      </Card>
    </div>
  );
}
